import './Alert.scss';

import PropTypes from 'prop-types';
import React from 'react';
import Constants from 'Shared/constants';

const Alert = ({ type, children, className, display }) => {
	return (
		<div className={`${className} react__alert ${type}`} data-display={display}>
			{children}
		</div>
	);
};

Alert.propTypes = {
	type: PropTypes.oneOf(Constants.TYPES),
	children: PropTypes.any,
	className: PropTypes.string,
	display: PropTypes.oneOf(['block', 'inline-block', 'flex'])
};

Alert.defaultProps = {
	type: 'primary',
	children: null,
	className: '',
	display: 'block'
};

export default Alert;
